import React from 'react';
import {
  Box,
  Container,
  Heading,
  Text,
  VStack,
  UnorderedList,
  ListItem,
  useColorModeValue,
} from '@chakra-ui/react';

export default function PrivacyPolicy() {
  const bgColor = useColorModeValue('gray.50', 'gray.900');
  const textColor = useColorModeValue('gray.600', 'gray.400');
  const headingColor = useColorModeValue('blue.600', 'blue.300');

  return (
    <Box bg={bgColor} color={textColor} minHeight="100vh" py={12}>
      <Container maxW="4xl">
        <VStack spacing={8} align="stretch">
          <Heading as="h1" size="2xl" color={headingColor} textAlign="center">
            Datenschutzerklärung
          </Heading>

          <Text>
            Willkommen bei Quodara Chrono. Der Schutz Ihrer persönlichen Daten ist uns ein wichtiges Anliegen. In dieser Datenschutzerklärung informieren wir Sie über die Erhebung, Verarbeitung und Nutzung Ihrer Daten bei der Nutzung unserer Dienste.
          </Text>

          <VStack spacing={4} align="stretch">
            <Heading as="h2" size="lg" color={headingColor}>
              1. Verantwortliche Stelle
            </Heading>
            <Text>
              Verantwortlich für die Datenverarbeitung ist:
              <br />
              Patrick Meyhöfer
              <br />
              Straßburger Ring 2
              <br />
              68229 Mannheim
              <br />
              Deutschland
            </Text>

            <Heading as="h2" size="lg" color={headingColor}>
              2. Erhebung und Verarbeitung von Daten
            </Heading>
            <Text>
              Bei der Nutzung unserer Dienste erheben wir folgende Daten:
            </Text>
            <UnorderedList pl={5}>
              <ListItem>Persönliche Informationen (Name, E-Mail-Adresse)</ListItem>
              <ListItem>Nutzungsdaten (IP-Adresse, Browsertyp)</ListItem>
              <ListItem>Zahlungsinformationen (bei kostenpflichtigen Diensten)</ListItem>
            </UnorderedList>

            <Heading as="h2" size="lg" color={headingColor}>
              3. Zweck der Datenverarbeitung
            </Heading>
            <Text>
              Wir verarbeiten Ihre Daten zu folgenden Zwecken:
            </Text>
            <UnorderedList pl={5}>
              <ListItem>Bereitstellung und Verbesserung unserer Dienste</ListItem>
              <ListItem>Kommunikation mit Ihnen</ListItem>
              <ListItem>Analyse der Nutzung unserer Dienste</ListItem>
            </UnorderedList>

            <Heading as="h2" size="lg" color={headingColor}>
              4. Ihre Rechte
            </Heading>
            <Text>
              Sie haben das Recht auf Auskunft, Berichtigung, Löschung und Einschränkung der Verarbeitung Ihrer personenbezogenen Daten. Zudem können Sie der Verarbeitung widersprechen und Ihre Einwilligung jederzeit widerrufen.
            </Text>

            <Heading as="h2" size="lg" color={headingColor}>
              5. Datensicherheit
            </Heading>
            <Text>
              Wir setzen technische und organisatorische Sicherheitsmaßnahmen ein, um Ihre Daten gegen zufällige oder vorsätzliche Manipulationen, Verlust, Zerstörung oder den Zugriff unberechtigter Personen zu schützen.
            </Text>

            <Heading as="h2" size="lg" color={headingColor}>
              6. Änderungen der Datenschutzerklärung
            </Heading>
            <Text>
              Wir behalten uns vor, diese Datenschutzerklärung bei Bedarf zu aktualisieren. Die aktuelle Version finden Sie stets auf dieser Seite.
            </Text>
          </VStack>

          <Text fontStyle="italic" mt={8}>
            Stand: 12. August 2024
          </Text>
        </VStack>
      </Container>
    </Box>
  );
}
